var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-days-before"},[_c('div',{staticClass:"empty-row"},[_c('div',{staticClass:"color-row",style:({'right': _vm.percent+'%'})}),_c('div',{staticClass:"bubble-days",style:({'right': _vm.percent+'%'})},[_vm._v(" "+_vm._s(_vm.daysBefore)+" ")])]),_c('h3',[_vm._v("Дней до зарплаты")])])
}
var staticRenderFns = []

export { render, staticRenderFns }